import { LoginCredentials, RegisterData, User, AuthResponse } from '../../features/shared/auth/domain';
import { get, post, patch } from '../core/http';

const BASE_PATH = '/auth';

export const authApi = {

  // Inicia sesión con credenciales de usuario
  login: (credentials: LoginCredentials): Promise<AuthResponse> =>
    post<AuthResponse>(`${BASE_PATH}/login`, credentials),

  // Registra un nuevo usuario
  register: (userData: RegisterData): Promise<AuthResponse> =>
    post<AuthResponse>(`${BASE_PATH}/register`, userData),

  // Obtiene el perfil del usuario autenticado
  getProfile: async (): Promise<User | null> => {
    return get<User>(`${BASE_PATH}/me`);
  },

  // Renueva el token de acceso
  refreshToken: (): Promise<{ access_token: string; refresh_token?: string }> =>
    post<{ access_token: string; refresh_token?: string }>(`${BASE_PATH}/refresh`, {}),

  // Cierra la sesión del usuario
  logout: (): Promise<void> =>
    post<void>(`${BASE_PATH}/logout`, {}),

  //Solicita el restablecimiento de contraseña
  requestPasswordReset: (email: string): Promise<void> =>
    post<void>(`${BASE_PATH}/forgot-password`, { email }),

  // Restablece la contraseña con un token
  resetPassword: (newPassword: string, token?: string): Promise<void> =>
    post<void>(`${BASE_PATH}/reset-password`, { token, newPassword }),

  // Inicia sesión con Google
  signInWithGoogle: (): Promise<AuthResponse> =>
    get<AuthResponse>(`${BASE_PATH}/google`),

  //  DEPRECADO: Usar login() en su lugar
  adminLogin: (credentials: LoginCredentials): Promise<AuthResponse> =>
    post<AuthResponse>(`${BASE_PATH}/login`, credentials),

  // Actualiza el perfil del usuario
  updateProfile: (userData: Partial<User>): Promise<User> =>
    patch<User>(`${BASE_PATH}/me`, userData),
};
